import script from "./ai-picture-select-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ai-picture-select-modal.vue?vue&type=script&setup=true&lang=ts"

import "./ai-picture-select-modal.vue?vue&type=style&index=0&id=0b816cf5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b816cf5"]])

export default __exports__